import logoF2 from './../../comum/assets/arbor.png';
import styles from './loading.css';

function Loading() {
        return (
            <div className="loader_container">
                <img className="img-mov" src={logoF2} alt="Loading" />
                <div className='texto-carregando'><h5>Carregando . . .</h5></div>
            </div>
            
            
        )

}

export default Loading